import styles from './Outlet.module.scss'
import { withRouter } from 'react-router-dom'
import BrandsPanel from '../Brands/BrandsPanel/BrandsPanel'
import ProductsTable from '../ProductsList/ProductsTable/ProductsTable'
import { useContext, useEffect, useMemo, useState } from 'react'
import getCollection from '../../../../utils/db/getCollection'
import { groupBy, orderBy } from 'lodash'
import promiseAllValues from '../../../../utils/promiseAllValues'
import { AuthContext } from '../../../../App'
import isCatalogFeedProduct from '../../../../utils/isCatalogFeedProduct'
import OutletManager from './OutletManager/OutletManager'
// import ProductsManager from './ProductsManager/ProductsManager'

const OUTLET_LIST_PATH = '/products/outlet/list'

function OutletList({ match, location, ...router }) {
  const { brandId: brandIdFromRoute, productId } = match.params
  const [brands, setBrands] = useState(null)
  const { setPageTitle } = useContext(AuthContext)

  const brandId = useMemo(() => {
    return (
      brandIdFromRoute ||
      getRouteBrandIdFromPath(location.pathname, OUTLET_LIST_PATH) ||
      getRouteBrandIdFromPath(router.location?.pathname, OUTLET_LIST_PATH) ||
      ''
    )
  }, [brandIdFromRoute, location.pathname, router.location?.pathname])

  useEffect(() => setPageTitle('Outlet каталог'), [setPageTitle])

  useEffect(() => {
    let isMounted = true

    promiseAllValues({
      outletProducts: getCollection({ path: 'outletProducts', docIdName: 'id' }),
      allBrands: getCollection({ path: 'brands', docIdName: 'id' }),
    }).then(({ outletProducts, allBrands }) => {
      if (!isMounted) return

      const outletProductsByBrandId = groupBy(
        outletProducts.filter((product) => product.brandId),
        'brandId'
      )

      const outletBrands = orderBy(
        allBrands
          .filter((brand) => outletProductsByBrandId[brand.id])
          .map((brand) => {
            const productsCount = outletProductsByBrandId[brand.id].filter(isCatalogFeedProduct)
              .length

            return {
              ...brand,
              productsCount,
              isDisabled: productsCount === 0,
            }
          }),
        ['name'],
        ['asc']
      )

      setBrands(outletBrands)
    })

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <div className={styles.root}>
      <BrandsPanel
        selectedBrandId={brandId}
        brands={brands}
        isLoading={brands === null}
        onClickPath={OUTLET_LIST_PATH}
        routerIdName="brandId"
        showInactiveReason={false}
        showProductsCount
      />
      {brandId && !productId && (
        <ProductsTable
          key={brandId}
          brandId={brandId}
          productsPath="outletProducts"
          productBasePath={OUTLET_LIST_PATH}
          variant="outlet"
        />
      )}
      {brandId && productId && <OutletManager />}
    </div>
  )
}

const getRouteBrandIdFromPath = (pathname, onClickPath) => {
  if (!pathname || !onClickPath || !pathname.startsWith(`${onClickPath}/`)) {
    return ''
  }

  return pathname.slice(onClickPath.length + 1).split('/')[0]
}

export default withRouter(OutletList)
